const rates = {
    "A0":{
        0 : 36.00,
        1 : 36.50,
        2 : 37.00,
        3 : 37.50,
        4 : 38.00,
        5 : 38.50,
        6 : 39.00,
        7 : 39.50,
        8 : 40.00,
        9 : 40.50,
        10: 41.00,
        11: 41.50,
        12: 42.00,
        13: 42.50,
        14: 42.50,
        15: 42.50,
        16: 43.00,
        17: 43.00,
        18: 43.50,
        19: 43.50,
        20: 44.00,
        21: 44.00,
        22: 44.00,
        23: 44.50,
        24: 44.50,
        25: 45.00,
        26: 45.00,
        27: 45.50,
        28: 45.50,
        29: 45.50,
        30: 46.00
    },
    "A3":{
        0 : 36.00,
        1 : 36.50,
        2 : 37.00,
        3 : 37.50,
        4 : 38.00,
        5 : 38.50,
        6 : 39.00,
        7 : 39.50,
        8 : 40.00,
        9 : 40.50,
        10: 41.00,
        11: 41.50,
        12: 42.00,
        13: 42.50,
        14: 42.50,
        15: 42.50,
        16: 43.00,
        17: 43.00,
        18: 43.50,
        19: 43.50,
        20: 44.00,
        21: 44.00,
        22: 44.00,
        23: 44.50,
        24: 44.50,
        25: 45.00,
        26: 45.00,
        27: 45.50,
        28: 45.50,
        29: 45.50,
        30: 46.00
    },
    "A1": {
        0 : 44.00,
        1 : 44.50,
        2 : 45.00,
        3 : 45.50,
        4 : 46.00,
        5 : 46.50,
        6 : 47.00,
        7 : 47.50,
        8 : 48.00,
        9 : 48.50,
        10: 49.00,
        11: 49.50,
        12: 50.00,
        13: 50.50,
        14: 51.00,
        15: 51.50,
        16: 52.00,
        17: 52.50,
        18: 53.00,
        19: 53.50,
        20: 54.00,
        21: 54.50,
        22: 55.00,
        23: 55.50,
        24: 56.00,
        25: 56.50,
        26: 57.00,
        27: 57.00,
        28: 57.00,
        29: 57.00,
        30: 57.00,
    },
    "A2": {
        0 : 42.00,
        1 : 42.50,
        2 : 43.00,
        3 : 43.50,
        4 : 44.00,
        5 : 44.50,
        6 : 45.00,
        7 : 45.50,
        8 : 46.00,
        9 : 46.50,
        10: 47.00,
        11: 47.50,
        12: 48.00,
        13: 48.50,
        14: 49.00,
        15: 49.50,
        16: 50.00,
        17: 51.50,
        18: 52.00,
        19: 52.50,
        20: 53.00,
        21: 53.50,
        22: 54.00,
        23: 54.50,
        24: 55.00,
        25: 55.00,
        26: 55.00,
        27: 55.00,
        28: 55.00,
        29: 55.00,
        30: 55.00,
    }
}

export const FeeCalculator = (years, func) => {
    if(!rates.hasOwnProperty(func)) return -1;

    const ratesToChooseFrom = rates[func];

    const roundedYears = Math.round(Number(years));

    if(isNaN(roundedYears)) return -1;

    if(roundedYears > 30) return ratesToChooseFrom[30];
    if(ratesToChooseFrom.hasOwnProperty(roundedYears)) return ratesToChooseFrom[roundedYears];

    return -1;
}